import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../../shared/services/utils.service';

@Component({
  selector: 'app-fly-conditions',
  templateUrl: './fly-conditions.component.html',
  styleUrls: ['./fly-conditions.component.scss']
})
export class FlyConditionsComponent implements OnInit {

  // tslint:disable-next-line:variable-name
  constructor(public _ui: UtilsService) { }


  ngOnInit() {
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }

}
